var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg-gray-100 min-h-screen font-sans flex flex-col",class:[_vm.maxHScreen],attrs:{"id":"app"}},[_c('Transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('RouterView')],1),_c('portal-target',{attrs:{"name":"app-modal"}}),_c('portal-target',{attrs:{"name":"app-dialog","multiple":""}}),_c('app-modals')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }